<template>
    <div>
      <section id="app" class="app talisman-app wf-section bgMint">
      <div class="w-layout-blockcontainer main w-container"><img src="@/assets/images/buy_war.svg" loading="lazy" width="851.5" alt="" class="loader">
        <div class="div-block-5 div-block-6 div-block-7 div-block-8 div-block-9 div-block-10 div-block-11 div-block-12 div-block-13">
          <div class="subtext-main">WAR Points allow you to purchase avatars, upgrades, companions, and more within the ZERG ecosystem. Powered by AWRD.</div>
          <!-- <div><strong>Price: </strong>0.1<strong>Ξ</strong> </div>
          <div><strong>Supply: </strong>500</div> -->
        </div>
        <!-- <button @click="test_wallet_connect">TEST WALLET CONNECT</button>
        <button @click="test_wallet_connect_mint">TEST WALLET MINT</button> -->
        <LoginWith :disabled="isLoginDisabled" type="top" @login="() => handleLogin('LoadingView')" @appKeyFound="() => handleLogin('LoadingView')" @error="handleError"></LoginWith>
        <div v-if="requireCheck" class="terms-container">
            <input type="checkbox" v-model="termsAccepted" id="termsCheckbox">
            <label for="termsCheckbox">By using this site you accept the platform's <a class="underline" href="https://zerg.studio/legal">terms and conditions</a></label>
        </div>

        <div v-else class="terms-container">
            <p class="tos-text">By using this site you accept the platform's <a class="underline" href="https://zerg.studio/legal">terms and conditions</a></p>
        </div>
        <!-- <PurchasePass @error="handleError"></PurchasePass> -->
        <!-- <LoginWith @login="() => handleLogin('LoadingView')" @appKeyFound="() => handleLogin('LoadingView')" @error="handleError"></LoginWith> -->
        <!-- <a href="https://awrd.gg/5886" target="_blank" class="anointed w-inline-block">
        <div class="claimbadge"><img src="@/assets/images/5886.png" loading="lazy" width="50" height="50" srcset="@/assets/images/5886.png 500w, @/assets/images/5886.png 512w" sizes="50px" alt="">
          <div class="text-block-4">Collect a Warrior Talisman for a half-priced mint</div>
        </div>
      </a> -->
      </div>
    </section>
</div>
  </template>
  
  <script>
  import { ref, computed } from 'vue'
  import { useEligibilityStore } from '../store/eligibility'
  import LoginWith from '../components/LoginWith.vue'
  // import PurchasePass from '../components/PurchasePass.vue'
  import { useContractStore } from '../store/contract'
//   import LoadingView from './LoadingView.vue'
//   import ConfirmationView from './ConfirmationView.vue'
  
  export default {
    name: 'index',
    components: {
      LoginWith,
      // PurchasePass
    },
    setup(props, { emit }) {
      // const eligibilityStore = useEligibilityStore()
      const currentView = ref('LoginWith')
      const errorMessage = ref(null)
      const termsAccepted = ref(false)
      const requireCheck = ref(false)
      const isLoginDisabled = computed(() => {
        return requireCheck.value && !termsAccepted.value
      })
      const test_wallet_connect = () => {
        const contractStore = useContractStore()
        contractStore.initialize()
      }
      const test_wallet_connect_mint = async () => {
        const contractStore = useContractStore()
        await contractStore.mint(15)
      }
      const handleError = (error) => {
        errorMessage.value = error
        setTimeout(() => { errorMessage.value = null }, 5000) // Error message will disappear after 5 seconds
      }
  
      const handleLogin = async (view="LoadingView", skip=false) => {
        if(skip){
          const eligibilityStore = useEligibilityStore()
          eligibilityStore.skip = true
        }
        emit('next', view)
      }
      
  
      return {
        currentView,
        handleLogin,
        handleError,
        errorMessage,
        test_wallet_connect,
        test_wallet_connect_mint,
        termsAccepted,
        requireCheck,
        isLoginDisabled
      }
    },
  }
  </script>
  
  <style>
  .tos-text{
    color: #ffffff;
  }
  .subtext-main{
    padding:1rem;
    color: #cf0;
    max-width:500px;
    text-align:center;
  }
  .buttons{
    height: 500px;
  }
  .error-message {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: red;
    color: white;
    padding: 1em;
    text-align: center;
  }
  .anointed{
    margin-top: 2rem;
  }
  .terms-container{
    display:flex;
    justify-content: center;
    align-items: center;
    justify-items: center;
    color:#cf0;
    gap:.5rem;
    font-size: 10px;
  }
  .underline{
      color: white;
      text-decoration: underline;

    }
  input[type="checkbox"]:checked + label {
  color: #cf0;
  }

  input[type="checkbox"]:before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 0.5rem;
    border: 2px solid #cf0;
    vertical-align: middle;
  }

  input[type="checkbox"]:checked:before {
    background-color: #cf0;
  }
  </style>
  